import React from 'react';
import { styles } from '../../config/styles';
import CanvasJSReact from '@canvasjs/react-charts';
import { useChartOptions } from '../../hooks/useChartOptions';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const ResultsModal = ({ isOpen, onClose, votesConcept, chainConcept }) => {
    const { conceptChartOptions, chainChartOptions } = useChartOptions(votesConcept, chainConcept);

    if (!isOpen) return null;

    return (
        <div className={styles.modal.overlay}>
            <div className={styles.modal.content}>
                <div className="flex justify-end mb-4">
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        ×
                    </button>
                </div>

                <CanvasJSChart options={conceptChartOptions} />
                <div className="my-4"></div>
                <CanvasJSChart options={chainChartOptions} />

                <div className="mt-4">
                    <button
                        className={`btn ${styles.button.base} ${styles.button.primary}`}
                        onClick={onClose}
                    >
                        Close Results
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResultsModal;